import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import {
  DEFAULT_GET_ALL_LIMIT,
  DEFAULT_STALE_TIME_MS,
} from '../../utils/constants'

import { reportingEventApi } from './services'
import { CreateReportingEventRequest, ReportingEventListParams } from './types'

const REPORTING_EVENT_LIST_QUERY_KEY = (params?: ReportingEventListParams) => [
  'reporting-event-list',
  params,
]

export const useReportingEventList = (
  params?: ReportingEventListParams,
  options?: { enabled?: boolean }
) => {
  const trimmedSearch = params?.q?.trim()
  const effectiveSearch = trimmedSearch || undefined

  const effectiveParams = params
    ? {
        ...params,
        limit: DEFAULT_GET_ALL_LIMIT,
        q: effectiveSearch,
      }
    : {
        limit: DEFAULT_GET_ALL_LIMIT,
      }

  return useQuery({
    queryKey: REPORTING_EVENT_LIST_QUERY_KEY(effectiveParams),
    queryFn: async () => {
      const response =
        await reportingEventApi.getReportingEventList(effectiveParams)
      return response
    },
    enabled: options?.enabled ?? true,
    staleTime: DEFAULT_STALE_TIME_MS,
  })
}

export const useCreateReportingEvent = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: CreateReportingEventRequest) => {
      const response = await reportingEventApi.createReportingEvent(data)
      return response
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['reporting-event-list'],
      })
    },
  })
}
